<template>
  <div>
    <ParentBar />
    <PermissionValidation
      :marketId="marketId"
      rule="enableViewReports"
    >
      <layout :isSuccess="true">
        <template v-slot:containerZone>
          <report-layout>
            <router-view></router-view>
          </report-layout>
        </template>
      </layout>
    </PermissionValidation>
  </div>

</template>

<script>
import Layout from "../../components/Layout.vue";
import ParentBar from "../../components/ParentBar.vue";
import ReportLayout from "../../components/ReportLayout.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    Layout,
    ParentBar,
    ReportLayout,
    PermissionValidation
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
    }
  },
  computed:{
    css_media_style () { // creates a CSS <style> and returns it
      const style = document.createElement("style");
      document.head.appendChild(style);
      return style;
    }
  },
  mounted(){
    this.css_media_style.innerHTML = "@media print { @page { size: A4 landscape; margin: 38px !important; } * { font-family: 'Sarabun' !important; } }";
  }
};
</script>

<style>
</style>